import * as React from "react"
import { observer } from "mobx-react"

import { Box, CircularProgress, Typography } from "@mui/material"

import useScopedTranslation from "hooks/useScopedTranslation"
import en from "./locales/en.json"
import List, { ListTextItemTypes } from "../../../components/List"
import { useTecDocStore } from "../../../../../api/services/TecDoc"
import { useEffect, useMemo, useState } from "react"

import { createItemBorder, getDate, groupListByValue } from "../../../util"
import { calculateDateRange } from "../../util"
import { VehicleSelectionProps } from "./types"
import i18next from "i18next"
import { isAte } from "utils/Global"
export const namespace = __filename

const VehicleSelection: React.FC<VehicleSelectionProps> = (props) => {
  const lang = i18next.language
  const countryCatalogue = localStorage.getItem("countryCatalogueCode") || "de"

  const { step, handleStep } = props
  const { t } = useScopedTranslation(
    namespace,
    (locale) => import(`./locales/${locale}.json`),
    en
  )
  const tecDocStore = useTecDocStore()
  const {
    vehicleList,
    vehicleDetailsList,
    articleList,
    loadingVehicleList,
    loadingVehicleDetailsList,
    loadingArticleList,
  } = tecDocStore

  const [manufacturer, setManufacturer] = useState("")
  const [model, setModel] = useState("")
  const [typeKey, setTypeKey] = useState("")

  const vehicleListByManu = useMemo(() => {
    let tempArticleAttributes: ListTextItemTypes[] = []
    if (vehicleDetailsList) {
      tempArticleAttributes = Object.entries(vehicleDetailsList).map((item) => {
        return {
          key: String(item[1]?.vehicleDetails.carId),
          brand: item[1]?.vehicleDetails.manuName,
          modelName: item[1]?.vehicleDetails.modelName,
          yearFrom: item[1]?.vehicleDetails.yearOfConstrFrom,
          yearTo: item[1]?.vehicleDetails.yearOfConstrTo,
          subItems: [
            {
              label: String(
                `${item[1]?.vehicleDetails.modelName} ${item[1]?.vehicleDetails.typeName}`
              ),
              hasBoldLabel: true,
            },
            {
              label: `${t("motorCodes")}:`,
              content: item[1]?.motorCodes?.array
                .map((item) => item.motorCode)
                .toString(),
            },
            {
              label: `${t("yearOfConstruction")}:`,
              content: getDate(
                item[1]?.vehicleDetails.yearOfConstrFrom,
                item[1]?.vehicleDetails.yearOfConstrTo
              ),
            },
            {
              label: `${t("power")}:`,
              content: `${item[1]?.vehicleDetails.powerHpTo} ${t("units.hp")}/${
                item[1]?.vehicleDetails.powerKwTo
              } ${t("units.kw")}`,
            },
            {
              label: `${t("cylinderCapacity")}:`,
              content: `${item[1]?.vehicleDetails.ccmTech} ${t("units.ccm")}`,
            },
          ],
        }
      })
    }
    const tempListByBrand = Object.entries(
      groupListByValue(tempArticleAttributes, "brand")
    ) //.filter((item) => ["articleName", "articleSearchNo", "articleNo",].includes(item.label))
    const tempListByModelAndBrand = tempListByBrand.map((item) => {
      return {
        brand: item[0],
        modelsList: groupListByValue(item[1], "modelName"),
      }
    })
    return tempListByModelAndBrand //.filter((item) => ["articleName", "articleSearchNo", "articleNo",].includes(item.label))
  }, [vehicleDetailsList, t])

  const manufacturerList = useMemo(() => {
    return (
      <List
        type={"LINK"}
        key={"manufacturer"}
        title={"Select Manufacturer"}
        items={createItemBorder(
          vehicleListByManu.map((item) => {
            return {
              key: String(item.brand),
              brand: item.brand,
              subItems: [
                {
                  label: String(item.brand),
                  hasBoldLabel: true,
                },
              ],
              onClick: () => {
                setManufacturer(item.brand)
                handleStep(1)
              },
            }
          })
        )}
      />
    )
  }, [vehicleListByManu, handleStep])

  const modelList = useMemo(() => {
    if (vehicleListByManu) {
      const manuIndex = vehicleListByManu.findIndex(
        (p) => p.brand === manufacturer
      )

      return manuIndex >= 0 ? (
        <List
          type={"LINK"}
          key={"model"}
          title={"Select model"}
          items={createItemBorder(
            Object.entries(vehicleListByManu[manuIndex].modelsList).map(
              (item) => {
                return {
                  key: String(item[0]),
                  subItems: [
                    {
                      label: String(`${manufacturer} ${item[0]}`),
                      hasBoldLabel: true,
                    },
                    {
                      label: String(calculateDateRange(item[1])),
                      hasBoldLabel: false,
                    },
                  ],
                  onClick: () => {
                    setModel(item[0])
                    handleStep(1)
                  },
                }
              }
            )
          )}
        />
      ) : (
        <></>
      )
    }
  }, [vehicleListByManu, handleStep, manufacturer])

  const typeList = useMemo(() => {
    if (vehicleListByManu && step > 1) {
      console.log(model)

      const manuIndex = vehicleListByManu.findIndex(
        (p) => p.brand === manufacturer
      )

      // const tempTypeList = vehicleListByManu[0].modelsList[model]

      return manuIndex >= 0 ? (
        <List
          type={"LINK"}
          key={"model"}
          title={"Select model"}
          items={
            manuIndex >= 0
              ? createItemBorder(
                  vehicleListByManu[manuIndex].modelsList[model].map((item) => {
                    return {
                      key: item.key,
                      subItems: item.subItems,
                      onClick: () => {
                        setTypeKey(item.key)
                        handleStep(1)
                      },
                    }
                  })
                )
              : []
          }
        />
      ) : (
        <></>
      )
    }
  }, [vehicleListByManu, manufacturer, model, step, handleStep])
/*
  const manualList = useMemo(() => {
    return (
      <List
        type={"LINK"}
        key={"manufacturer"}
        title={"Select Manufacturer"}
        items={createItemBorder(
          vehicleListByManu.map((item) => {
            return {
              key: String(item.brand),
              brand: item.brand,
              subItems: [
                {
                  label: String(item.brand),
                  hasBoldLabel: true,
                },
              ],
              onClick: () => {
                setManufacturer(item.brand)
                handleStep(1)
              },
            }
          })
        )}
      />
    )
  }, [vehicleListByManu, handleStep])
*/
  useEffect(() => {
    tecDocStore
      .fetchArticle(countryCatalogue, lang, 6, "4014486413878") // 4019064364931
      .catch((err) => console.log("Error fetching articles", err))
  }, [tecDocStore])

  useEffect(() => {
    if (articleList?.articleId) {
      tecDocStore
        .fetchVehicleList(countryCatalogue, lang, articleList.articleId)
        .catch((err) => console.log("Error fetching vehicles", err))
    }
  }, [tecDocStore, articleList])

  useEffect(() => {
    if (vehicleList) {
      const vehicleIds = vehicleList.map((item) => item.linkingTargetId)

      tecDocStore
        .fetchVehicleDetailList(countryCatalogue, lang, vehicleIds)
        .catch((err) => console.log("Error fetching vehicle details", err))
    }
  }, [tecDocStore, vehicleList])

  return (
    <Box>
      {loadingArticleList || loadingVehicleList || loadingVehicleDetailsList ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="10vh"
          sx={{ flexDirection: "column" }}
        >
          <CircularProgress color={"primary"} size="5vh" />
        </Box>
      ) : (
        <Box>
          <Typography sx={{ paddingY: 1 }} variant={"h5"} >
            {vehicleDetailsList?.length} {t("linkedVehicles")}
          </Typography>
          {(step === 0 && <Box>{manufacturerList}</Box>) ||
            (step === 1 && <Box>{modelList}</Box>) ||
            (step === 2 && <Box>{typeList}</Box>)}
        </Box>
      )}
    </Box>
  )
}

export default observer(VehicleSelection)
